import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { uploads, API_URL } from "../config";

const Photogallery = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  const [index, setIndex] = useState(-1);

  useEffect(() => {
    if (!slug) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `${API_URL}/api-get-business-details.php?slug=${slug}`
        );

        const result = await res.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [slug]);

  // safely extract images
  const images =
    data?.data?.photogallery
      ?.split(",")
      .map(img => img.trim())
      .filter(Boolean) || [];

  const activeImage =
    index >= 0 ? `${uploads}/${images[index]}` : null;

  const next = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev + 1) % images.length);
  };

  const prev = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // ESC key close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIndex(-1);
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div>
      {images.length > 0 && (
        <div className="gallery-box">
          <h2>Photo Gallery</h2>

          <div className="row">
            {images.map((img, i) => (
              <div className="col-md-2" key={i}>
                <div className="gall-box">
                  <img
                    src={`${uploads}/${img}`}
                    className="fullimg"
                    alt={`Gallery ${i}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setIndex(i)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* LIGHTBOX */}
{index >= 0 && (
  <div className="lightbox" onClick={() => setIndex(-1)}>

    {/* Close Button */}
    <button
      className="close-btn"
      onClick={(e) => {
        e.stopPropagation();
        setIndex(-1);
      }}
    >
      ✕
    </button>

    <button className="nav prev" onClick={prev}>
      ❮
    </button>

    <div className="lightbox-img-wrapper" onClick={(e) => e.stopPropagation()}>
  <img src={activeImage} alt="" />
</div>

    <button className="nav next" onClick={next}>
      ❯
    </button>
  </div>
)}
    </div>
  );
};

export default Photogallery;